/**
 * - `public/logoW-transparent.png` — **мастер** (светлый лотос, прозрачный фон) → **тёмная** тема.
 * - `public/logo.png` — **собирается** из мастера (`npm run build:logos` / `scripts/build-logo-assets.py`):
 *   тёмный лотос, прозрачный фон → **светлая** тема.
 * Трогай `?v=` в URL при смене ассетов.
 */
export const LOTOS_LOGO_LIGHT = '/logo.png?v=4'
export const LOTOS_LOGO_DARK = '/logoW-transparent.png?v=4'
